import Scrib from "./components/scrib/Scrib";
import Faq from "./components/faq/Faq";
import Footer from "./components/footer/Footer";

import Hero from "./components/hero/Hero";
import Navbar from "./components/navbar/Navbar";

import Team from "./components/team/Team";
import Roadmap from "./components/roadmap/Roadmap"
import "./App.css"
import Mint from "./components/mint/Mint";
import Traits from "./components/traits/Traits";
import Util from "./components/util/Util";
function App() {
  return (
    <div>
      <div className=" bg-scribe">
        <Navbar/>
        <Hero/>
        <Scrib/>
        <Roadmap/>
        <Mint/>
        <Team/>
        <Util/>
        <Traits/>
        <Faq/>
        <Footer/>
        </div>
    </div>
  );
}

export default App;
